import { EditAreasView } from './EditAreasView'

export const EditAreas = () => {
  return <EditAreasView />
}
